const ComponentType = {
  SYSTEM: 1,
  SUBSYSTEM: 2,
  DATALOGGER: 3,
  INVERTER: 4,
  SENSOR: 5,
  METER: 6,
  PPC: 7,
  BATTERY: 8,
  TRACKER: 9,
  STRINGBOX: 10,
  STATUS: 11,
  GENSET: 12,
};

export default ComponentType;
